/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".title[_ngcontent-%COMP%]{color:#231d19;font-family:\"Itau Display\";font-size:24px;font-weight:300;letter-spacing:0;line-height:32px}.description[_ngcontent-%COMP%]{color:#231d19;font-family:\"Itau Text\";font-size:16px;letter-spacing:0;line-height:24px}.note[_ngcontent-%COMP%]{margin-bottom:20px}.note[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{color:#56504c;font-size:14px;letter-spacing:.4px;line-height:20px}"];
export { styles as styles };
